<template>
  <WsDataTableWithTitle001
    table-overflow
    :isloading="true"
    :title="'YYYY'"
    :subtitle="'YYYY-MM'"
    :remark="'共{number}份記錄'"
    :column-header="header"
    :row-data="rowData"
    class="mt-40"
  />
</template>

<script>
export default {
  data() {
    return {
      header: [
        {
          id: "result",
          textLabel: `${this.$t("結果")}`,
          type: "icon",
          tabletHide: false,
        },
        {
          id: "date",
          textLabel: `${this.$t("日期")}`,
          type: "text",
          tabletHide: false,
        },
        {
          id: "title",
          textLabel: `${this.$t("名稱")}`,
          type: "text",
          tabletHide: false,
        },
        {
          id: "systemSubclasses",
          textLabel: `${this.$t("子領域")}`,
          type: "chips",
          tabletHide: false,
        },
        {
          id: "riskScore",
          textLabel: `${this.$t("不合規題數")}`,
          type: "risk-score",
          tabletHide: false,
        },
        {
          id: "auditor",
          textLabel: `${this.$t("稽核者")}`,
          type: "text",
          tabletHide: true,
        },
        {
          id: "auditee",
          textLabel: `${this.$t("受稽者")}`,
          type: "text",
          tabletHide: true,
        },
        {
          id: "download",
          icon: "icon-cloud-download",
          textLabel: `${this.$t("匯出")}`,
          type: "downloadPopup",
          tabletHide: true,
        },
      ],
      rowData: [
        {
          id: 136,
          title: "我是個沒有題目的稽核表-v2 測試稽核表綁建築法規及法條",
          systemSubclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
          ],
          result: "icon-risk-high-filled",
          risk: "red",
          date: "2022.12.15",
          auditee: "尚未回覆",
          auditor: "尚未回覆",
          download: [
            { text: "匯出 xlsx", value: "xlsx", id: 2 },
            { text: "匯出 csv", value: "csv", id: 3 },
            { text: "匯出與列印", value: "print", id: 4 },
            {
              text: "匯出 PDF (即將上線)",
              value: "pdf",
              id: 1,
              disabled: true,
            },
          ],
          riskScore: { major: 1, minor: 0, ofi: 0 },
        },
        {
          id: 135,
          title: "我是個沒有題目的稽核表-v2 測試稽核表綁建築法規及法條",
          systemSubclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
          ],
          result: "icon-risk-high-filled",
          risk: "red",
          date: "2022.12.15",
          auditee: "尚未回覆",
          auditor: "尚未回覆",
          download: [
            { text: "匯出 xlsx", value: "xlsx", id: 2 },
            { text: "匯出 csv", value: "csv", id: 3 },
            { text: "匯出與列印", value: "print", id: 4 },
            {
              text: "匯出 PDF (即將上線)",
              value: "pdf",
              id: 1,
              disabled: true,
            },
          ],
          riskScore: { major: 1, minor: 0, ofi: 0 },
        },
        {
          id: 132,
          title: "我是個沒有題目的稽核表-v2 測試稽核表綁建築法規及法條",
          systemSubclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
          ],
          result: "icon-risk-high-filled",
          risk: "blue",
          date: "2022.12.13",
          auditee: "尚未回覆",
          auditor: "尚未回覆",
          download: [
            { text: "匯出 xlsx", value: "xlsx", id: 2 },
            { text: "匯出 csv", value: "csv", id: 3 },
            { text: "匯出與列印", value: "print", id: 4 },
            {
              text: "匯出 PDF (即將上線)",
              value: "pdf",
              id: 1,
              disabled: true,
            },
          ],
          riskScore: { major: 0, minor: 0, ofi: 1 },
        },
        {
          id: 131,
          title: "我是個沒有題目的稽核表-v2 測試稽核表綁建築法規及法條",
          systemSubclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
          ],
          result: " icon-check-circle-filled",
          risk: "green",
          date: "2022.12.13",
          auditee: "蔡A辣",
          auditor: "尚未回覆",
          download: [
            { text: "匯出 xlsx", value: "xlsx", id: 2 },
            { text: "匯出 csv", value: "csv", id: 3 },
            { text: "匯出與列印", value: "print", id: 4 },
            {
              text: "匯出 PDF (即將上線)",
              value: "pdf",
              id: 1,
              disabled: true,
            },
          ],
          riskScore: { major: 0, minor: 0, ofi: 0 },
        },
        {
          id: 130,
          title: "我是個沒有題目的稽核表-v2 測試稽核表綁建築法規及法條",
          systemSubclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
          ],
          result: "icon-risk-high-filled",
          risk: "yellow",
          date: "2022.12.13",
          auditee: "蔡A辣",
          auditor: "尚未回覆",
          download: [
            { text: "匯出 xlsx", value: "xlsx", id: 2 },
            { text: "匯出 csv", value: "csv", id: 3 },
            { text: "匯出與列印", value: "print", id: 4 },
            {
              text: "匯出 PDF (即將上線)",
              value: "pdf",
              id: 1,
              disabled: true,
            },
          ],
          riskScore: { major: 0, minor: 1, ofi: 0 },
        },
      ],
    }
  }
}
</script>